import React, { useMemo } from 'react';
import { useFlexLayout, useTable, useSortBy } from 'react-table';

import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import { useAdvancedShippingNoticeContext } from '../../../advanced-shipping-notice-context';
import { createSkuColumnDefinition } from './columns/sku';
import { createNameColumnDefinition } from './columns/name';
import { createQuantityColumnDefinition } from './columns/quantity';
import { createDangerousGoodsColumnDefinition } from './columns/dangerous-goods';
import { createActionsColumnDefinition } from './columns/actions';
import { createReceivedQuantityColumnDefinition } from './columns/received-column';

import styles from './select-products-table.module.less';

export const SelectProductsTable = ({ data, handleProductQuantityChange, handleProductDeleted, isReadOnly }) => {
  const { isDraft } = useAdvancedShippingNoticeContext();
  const shouldShowReceivedColumn = !isDraft;

  const columns = useMemo(
    () => [
      createSkuColumnDefinition(),
      createNameColumnDefinition(),
      createQuantityColumnDefinition(),
      createReceivedQuantityColumnDefinition(),
      createDangerousGoodsColumnDefinition(),
      createActionsColumnDefinition(),
    ],
    [],
  );

  const hiddenColumns = useMemo(() => {
    const columnsToHide = [];
    if (isReadOnly) {
      columnsToHide.push('actions');
    }
    if (!shouldShowReceivedColumn) {
      columnsToHide.push('receivedQuantity');
    }
    return columnsToHide;
  }, [isReadOnly, shouldShowReceivedColumn]);

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns,
      },
      handleProductQuantityChange,
      handleProductDeleted,
      isReadOnly,
      disableSortRemove: true,
    },
    useSortBy,
    useFlexLayout,
  );

  return (
    <ReactTableWrapper
      className={styles.table}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      prepareRow={prepareRow}
      rows={rows}
    />
  );
};
